import session from '../auth_api/session'

const URL = process.env.VUE_APP_API_URL

export default {
  namespaced: true,
  state: {
    data: { 'results': [] }
  },
  mutations: {
    setData (state, payload) {
      state.data = payload
    },
    setItem (state, payload) {
      let data = state.data.results
      for (let i in data) {
        if (data[i]['id'] === payload.id) {
          Object.assign(data[i], payload)
          break
        }
      }
    }
  },
  actions: {
    fetchData ({ commit }, payload) {
      let _url = URL + 'school/api/' + payload.table + '/'
      let params = {}
      params['food_id'] = payload.food_id
      if (payload.num_class > '') {
        params['num_class'] = payload.num_class
      }
      if (payload.letter_class > '') {
        params['letter_class'] = payload.letter_class
      }
      if (payload.npd_num > '') {
        params['npd_num'] = payload.npd_num
      }
      if (payload.search > '') {
        params['search'] = payload.search
      }
      if ((0 + payload.pageId > 1) && !payload.search) {
        params['page'] = payload.pageId
      }
      return session.get(_url, { params: params })
    },
    updateData ({ commit }, payload) {
      return session.put(URL + 'school/api/' + payload.table + '/' + payload.item.id + '/', payload.item)
    }
  },
  getters: {
    data (state) {
      return state.data
    }
  }
}
